import type { FC } from 'react';
import { ProductType } from '../../../../../products/types';
import { useTranslation } from 'react-i18next';
// @dynamic-i18n-keys
// Dynamic t() at line 24 (common.productCategory.${productType}):
//   common.productCategory.exclusive
//   common.productCategory.exclusive_resale
//   common.productCategory.pcp
//   common.productCategory.premium_gallery
//   common.productCategory.commission
//   common.productCategory.originals
//   common.productCategory.tier
import ProductTypeIcon from '../../../../SoldProducts/ProductTypeIcon';
import { PapiDataPackageSellerOverview } from '@wix/da-papi-types';

import s from './SoldProductsTableRowHeadingMobile.scss';

interface Props {
  item: NonNullable<
    PapiDataPackageSellerOverview['timePeriods']['ALL']
  >[number];
}

const SoldProductsTableRowHeadingMobile: FC<Props> = ({ item }) => {
  const { t } = useTranslation();

  const productType = item.productType as ProductType;

  return (
    <div className={s['root']}>
      <ProductTypeIcon productType={productType} size={40} />
      <div className={s['product-type']}>
        {t(`common.productCategory.${productType}`)}
      </div>
    </div>
  );
};
SoldProductsTableRowHeadingMobile.displayName =
  'SoldProductsTableRowHeadingMobile';

export default SoldProductsTableRowHeadingMobile;
